import React from 'react';

const NotFound = () => (
  <div>
    <div className="container">
      <h2>Error</h2>
      <p>Page not found :\</p>
    </div>
  </div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.js